module.exports = __webpack_public_path__ + "img/mascot_head.5c0c37c6.svg";